import React from "react";

import "./Paper.scss";

const Paper = (props) => {
  const { children, className } = props;

  return (
    <div className={`custom-paper ${className ? className : ""}`}>
      {children}
    </div>
  );
};

export default Paper;
